<template>
  <div class="section-category section-full" @scroll="onScroll">
    <h2 class="ttl2 popup-header" v-translate >stock delivery</h2>
    <div class="input-group mb-3 col-3 float-right">
      <input type="text" class="form-control" id="input-search" v-model="filterByName" placeholder="Search by article name..." aria-label="Recipient's username" aria-describedby="basic-addon2">
    </div>
    <div class="inner-delivery popup-content" >
      <table class="table">
        <thead>
          <tr>
            <th class="text-left" width="160px">
              <v-select :class="{'no-show': !showDropdown, 'custom-select-filter': true}"
                  v-model="filter.category"
                  :options="managementGroups"
                  :ref="'category'"
                  label="name"
                  :placeholder="$gettext('Management Group')"
                  @search:focus="onFocus('category')"
                  @search="onSearch"
                >
                  <template slot="no-options">
                    {{ $gettext('No results found') }} ..
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }}
                    </div>
                  </template>
                </v-select>
            </th>
            <th class="text-left" v-translate>Article Name</th>
            <th class="text-center" v-translate>Alarm Level</th>
            <th class="text-center" v-translate>Standard Order</th>
            <th v-translate>Buying Price</th>
            <th v-translate>Size</th>
            <th v-translate>Count</th>
            <th v-translate>Current Count</th>
            <th style="width: 130px" v-translate>Delivery</th>
            <!--
            <th width="140px">Location</th>
            -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in stockItemFiltered">
            <td class="text-left">{{ printName(item.managementGroup, 'managementGroups') }}</td>
            <td class="text-left">{{ item.name }}</td>
            <td>{{ item.alarmLevel }}</td>
            <td>{{ item.standardOrder }}</td>
            <td>{{ item.cost | currency}}</td>
            <td>{{ item.size }} {{ printName(item.unit, 'units') }}</td>
            <td>{{ printName(item.count, 'counts') }}</td>
            <td>{{ 1*(Math.round($store.getters.getCurrentCount(item.id) + "e+2")  + "e-2") }}</td>
            <td>
              <input-pad
                :item="deliveries"
                :property="item.id"
                :id="'stock-item-delivery'"
                :attributes="{'class': 'delivery'}"
                :usingDecimal="true"
                />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-confirm-undo popup-action" :style="{'top': scrollTop}">
      <button type="button" class="btn btn-confirm" @click="submitDelivery()" v-translate>Confirm</button>
      <button type="button" class="btn btn-cancel" @click="$router.go(-1)" v-translate>Cancel</button>
<!--      <button type="button" class="btn btn-undo" @click="undo()" v-translate>Undo</button>-->
    </div>
  </div>
</template>

<script>
import StockService from '@/services/StockService';
import CategoryService from '@/services/CategoryService';
import { mapState, mapMutations } from 'vuex';
import { ON_INPUT_PAD_BLUR } from '@/store/mutation-types';

export default {
  name: 'StockDelivery',
  data() {
    return {
      scrollTop: 0,
      showDropdown: false,
      filterByName: '',
      editHistory: [],
      oldStockItems: [],
      undoFlag: false,


      deliveries: {},
      filter: {
        category: null,
      },
      select: {
        category: null,
        current: null,
      },

    };
  },
  computed: {
    inputPadUpdate: {
      get() { return this.getMap('inputHolderFocusing', true); },
      set(value) { this.$store.state.inputPad.inputHolderFocusing = value; },
    },
    managementGroups() {
      const vary = this.inputPadUpdate;
      return this.getArray('managementGroups');
    },
    stockItems() {
      const stockItems = [];
      const stockItemMasterList = this.getArray('stockItems', false, true);
      const stockItemCloneList = this.$store.getters.getCloneStockItemList;
      stockItemMasterList.forEach((stockItem) => {
        const clone = this.$store.getters.getStockItemClone(stockItem, stockItemCloneList);
        stockItems.push(clone || stockItem);
      });
      return stockItems;
    },
    stockItemFiltered() {
      const stockItems = this
        .stockItems
        .filter(
          item => (this.filter.category
            ? (this.filter.category.id === item.managementGroup
                            || this.deliveries[item.id])
            : true),
        );

      return stockItems.filter(item => item.name.toLowerCase().indexOf(this.filterByName.toLowerCase()) > -1);
    },
    station() { return this.getMap('user', true).station; },
  },
  methods: {
    async submitDelivery() {
      const stockData = {
        station: this.station.id,
        stocks: [],
      };
      for (const key in this.deliveries) {
        if (!this.deliveries[key]) continue;
        const stock = this.$store.getters.getStock(key);
        stockData.stocks.push({
          id: stock ? stock.id : 0,
          stockItem: key,
          currentCount: 1 * this.deliveries[key],
        });
      }
      await StockService.newDelivery(stockData);
      for (const key in this.deliveries) {
        this.deliveries[key] = '';
      }
      this.inputPadUpdate = 1;
    },
    // undo() {
    //   const lastChange = this.editHistory.pop();
    //   if (!lastChange) return;
    //   this.undoFlag = true;
    //   this.stockItems.find(({ id }) => id === lastChange.id).delivery = lastChange.oldValue;
    // },
    onScroll(event) {
      this.scrollTop = `${event.target.scrollTop}px`;
      this.$store.commit(ON_INPUT_PAD_BLUR, true);
    },
    onFocus(selectId) {
      this.select[selectId] = null;
      this.filter[selectId] = null;
      this.select.current = selectId;
      this.showDropdown = this.$refs[selectId].mutableOptions.length > 0;
    },
    onSearch(search) {
      this.select[this.select.current] = search;
    },
  },
  watch: {
    stockItems: {
      handler(value) {
        this.deliveries = {};
        this.stockItems.forEach((stockItem) => {
          this.deliveries[stockItem.id] = '';
        });
      },
      deep: true,
    },
  },
  async mounted() {
    this.deliveries = {};
    this.stockItems.forEach((stockItem) => {
      this.deliveries[stockItem.id] = '';
    });
  },
};
</script>
<style lang="scss">
  #input-search::placeholder {
      font-style: italic !important;
  }
</style>
